import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Margin, Padding, Queue, Stack, Text } from '../../components';
import { coreValuesData } from './shared';

const IconWrapper = styled.div`
  height: 20px;
  width: 20px;
`;

const CoreValuesComponent = (props) => {
  let { startingIndex, endingIndex } = props;
  return (
    <>
      {_.flow(
        (coreValuesData) =>
          _.map(coreValuesData, (coreValue, index) => {
            return (
              <Queue alignVertical="top" size={5} key={index}>
                <IconWrapper>{coreValue?.icon}</IconWrapper>

                <Stack size={2}>
                  <Text align="left" textType="primary1">
                    {coreValue?.title}
                  </Text>
                  <Text align="left" textType="primary2">
                    {coreValue?.description}
                  </Text>
                </Stack>
              </Queue>
            );
          }),
        (coreValuesData) => _.slice(coreValuesData, startingIndex, endingIndex)
      )(coreValuesData)}
    </>
  );
};

export const CoreValuesTablet = () => {
  return (
    <>
      <Padding size={[7]} backgroundRole="primary">
        <Stack size={6}>
          <Margin size={[0, 0, 4, 0]}>
            <Text textType="heading3">Our Values</Text>
          </Margin>
          <Margin size={[0, 8]}>
            <Stack size={5}>
              <CoreValuesComponent
                columns={6}
                startingIndex={0}
                endingIndex={6}
              />
            </Stack>
          </Margin>
        </Stack>
      </Padding>
    </>
  );
};
